export default __webpack_public_path__ + "static/media/pravnaPodpora.844e3677.webp";